/** Ordering helpers for feeder pickers and the feeder loading table (spec B6:
 *  dropdowns alphabetical; loading table worst-first). */

import type { FeederLoadingSummary } from '../types/engineering.ts'

/** Alphabetical, human-style ordering for dropdown options: case-insensitive,
 *  with numeric runs compared as numbers ("Feeder 2" before "Feeder 10").
 *  Sort by the SAME label string the option renders, so nameless items
 *  (fallback labels like "Feeder #12") order the way they read. */
export function sortByLabel<T>(items: readonly T[], label: (item: T) => string): T[] {
  return [...items].sort((a, b) =>
    label(a).localeCompare(label(b), undefined, { numeric: true, sensitivity: 'base' }),
  )
}

/** Worst-first ordering for the feeder loading table: loading% descending,
 *  null-loading feeders last (alphabetical among themselves). */
export function sortFeedersWorstFirst(
  feeders: readonly FeederLoadingSummary[],
): FeederLoadingSummary[] {
  return [...feeders].sort((a, b) => {
    if (a.loading_pct === null && b.loading_pct === null) {
      return (a.feeder_name ?? '').localeCompare(b.feeder_name ?? '', undefined, {
        numeric: true,
        sensitivity: 'base',
      })
    }
    if (a.loading_pct === null) return 1
    if (b.loading_pct === null) return -1
    return b.loading_pct - a.loading_pct
  })
}
